import React, { useState, useEffect } from "react";
import { Form, Table } from "react-bootstrap";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import { RightSideCountTop } from "./RightSideCountTop";
import SelectFilter from "../../reusableComponents/selectFilter";
import axios from "axios";
import { serverApi } from "../../../config/Keys";
import isEmpty from "../../../store/validation/is-Empty";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { OrderItemTaxReport } from "../../../store/actions/VendorReports/vendorReportsRestaurant";

import SmallLoader from "../../Loader/SmallLoader";

import moment from "moment";
import BasicPagination from "../../Pagination/Pagination";
import {
  ORDER_STATUS,
  ORDER_TYPE,
  PAYMENT_TYPE,
} from "../../../enums/OrderEnums";
import { SortComponent } from "../../reusableComponents/SortAndFilterComponent/SortComponent";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../navigationSection/RightSideNavigation";

const VendorOrderTaxReport = ({ ...props }) => {
  const [taxData, setTaxData] = useState([]);
  const [taxStat, setTaxStat] = useState({});
  const [search, setSearch] = useState("");
  const [dateQuery, setDateQuery] = useState({});
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [restaurantReverse, setRestaurantReverse] = useState(null);

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => (e) => {
    setRestaurantReverse(value);
    console.log(restaurantReverse);

    handleClose();
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      getReportData("tax", dateQuery);
    }
  }, [auth]);

  const getReportData = async (type, dateQuery) => {
    let data = await axios.get(`${serverApi}/vendor/order-reports`, {
      params: { reportType: type, ...dateQuery },
      headers: {
        Authorization: auth.accessToken,
        "Content-Type": "application/json",
      },
    });
    console.log(data.data);
    if (data.data) {
      setTaxData(data.data.orders);
      setTaxStat(data.data.stats[0]);
    }
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
    getReportData("tax", data);
  };

  let renderData = [];

  if (restaurantReverse === "A-Z") {
    renderData = taxData.sort((a, b) => {
      console.log(a.user_details.first_name);
      if (a.user_details.first_name < b.user_details.first_name) return -1;
      if (a.user_details.first_name > b.user_details.first_name) return 1;
      return 0;
    });
  } else if (restaurantReverse === "Z-A") {
    renderData = taxData.sort((a, b) => {
      console.log(a.user_details.first_name);
      if (a.user_details.first_name < b.user_details.first_name) return 1;
      if (a.user_details.first_name > b.user_details.first_name) return -1;
      return 0;
    });
  }

  renderData = taxData.filter((item) => {
    return (
      item?.order_id.toLowerCase().includes(search.toLowerCase()) ||
      item?.user_details?.last_name
        .toLowerCase()
        .includes(search.toLowerCase()) ||
      item?.user_details?.first_name
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  });

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            {/* <div className="super-admin-right-side-panel"> */}
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Order Tax Vendor Report
                </div>
                <div>
                  <div
                    className="f14-700 mb-2"
                    align="right"
                    style={{ color: "#EE3A23" }}
                  >
                    {moment().format("[Today,] Do MMM YYYY")}
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Net Orders Amount",
                        value: `₹ ${
                          taxStat?.totalBaseAmount
                            ? (taxStat?.totalBaseAmount)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                            : 0
                        }`,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Number of Items",
                        value: taxStat?.count ? taxStat?.count : 0,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Total Amount",
                        value: `₹ ${
                          taxStat?.totalAmount
                            ? (taxStat?.totalAmount)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                            : 0
                        }`,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="f10-400" align="center">
                      {/* <img
                        src={require("../../../assets/images/iconButton/sorticon.png")}
                        width="35px"
                      />
                      <br />
                        Sort */}
                      <SortComponent
                        handleClick={handleClick}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        selectClick={(data) => handleSelect(data)}
                      />
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                      />
                      <br />
                      Filter
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/downloadicon.png")}
                        width="35px"
                      />
                      <br />
                      Download
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "300px" }} className="f12-700">
                          Tax ID
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                          User
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Order Type/ <br />
                          Order ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Payment Method/ <br />
                          Transaction ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Gross <br />
                          Amount
                        </th>
                        <th style={{ width: "236px" }} className="f12-700">
                          Net Total <br />
                          Amount
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Discount
                        </th>
                        <th style={{ width: "250px" }} className="f12-700">
                          Refund/ <br />
                          Cancellation
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Substitution
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          SGST/ <br />
                          IGST
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Rate
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Total tax <br />
                          Value
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Order Date
                          <br /> & Time
                        </th>
                      </tr>
                    </thead>
                    {renderData &&
                      renderData.slice(start, end).map((data) => (
                        <tbody>
                          <tr className="super_admin_all_users_table_body">
                            <td style={{ width: "15%" }} className="f12-500">
                              {data?.order_id || ""}
                            </td>
                            <td style={{ width: "16%" }} className="f12-500">
                              <div class="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                                <div class="super-admin-suggestion-imageBoxTwo ml-2">
                                  <div class="f12-400">
                                    {`${data?.user_details?.first_name} ${data?.user_details?.last_name}`}{" "}
                                    <br />
                                    {`${data?.user_details?.country_code} ${data?.user_details?.mobile_number}`}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {ORDER_TYPE[data?.order_type]}
                              <br />
                              {data?.order_id || ""}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {PAYMENT_TYPE[data?.payment_method]}
                              <div className="f12-400">1245789632</div>
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {`₹ ${data?.total_amount || 0}`}
                            </td>
                            <td style={{ width: "15%" }} className="f12-500">
                              {`₹ ${data?.base_amount || 0}`}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {`₹ ${data?.discount?.amount || 0}`}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {`₹ ${data?.discount?.amount || 0}`}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {`₹ ${data?.discount?.amount || 0}`}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              ₹ 20 <br /> ₹ 10
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              10%
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {`₹ ${data?.tax_amount || 0}`}
                            </td>
                            <td style={{ width: "15%" }} className="f12-500">
                              {moment(data?.createdAt).format("ll")}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </Table>
                </div>
              </div>
              <div className="p4v2-menu-pagination">
                <BasicPagination
                  totalRecords={taxData?.length}
                  limit={5}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </React.Fragment>
  );
};

// VendorOrderTaxReport.propTypes = {
//   auth: PropTypes.object.isRequired,
//   errors: PropTypes.object.isRequired,
//   taxData: PropTypes.array.isRequired,
//   taxStat: PropTypes.array.isRequired,
// };

// const mapStateToProps = (state) => ({
//   taxData: state.reports.order_item_tax.data,
//   taxStat: state.reports.order_item_tax.stats,
//   auth: state.auth,
//   errors: state.errors.errors,
// });

// export default connect(mapStateToProps, {
//   clear_all_errors,
//   OrderItemTaxReport,
// })(VendorOrderTaxReport);

export default VendorOrderTaxReport;
